
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quest/[id]",
      function () {
        return require("private-next-pages/quest/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quest/[id]"])
      });
    }
  